<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('preInvoice.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('preInvoice.pageTitle'),
            href: '/pre-invoices'
          },
          {
            text: $t('add_new'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-6">
            <form>
              <fieldset>
                <legend>{{ $t('preInvoice.studentInfo') }}</legend>
                <student-list
                  v-model="model"
                  @student-info="student => (studentInfo = student)"
                  :validate="errors"
                />
              </fieldset>
            </form>
          </div>
          <div class="col-md-6">
            <academic
              v-model="model"
              :student-info="studentInfo"
              :validate="errors"
            />
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12">
            <panel :title="$t('preInvoice.item')">
              <item-list
                v-model="model"
                :student-info="studentInfo"
                :validate="errors"
              />
              <div class="d-flex justify-content-end">
                <ts-checkbox v-model="model.preview">{{
                  $t('preInvoice.previewPdfFile')
                }}</ts-checkbox>
              </div>
            </panel>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-right">
            <ts-button @click.prevent="$router.push({ name: 'pre-invoice' })">{{
              $t('cancel')
            }}</ts-button>
            <ts-button
              outline
              color="primary"
              class="ml-2 mr-2"
              :waiting="save_add_new_waiting"
              @click.prevent="saveAddNew"
              >{{ $t('save_add_new') }}</ts-button
            >
            <ts-button
              :waiting="save_waiting"
              @click.prevent="save"
              color="primary"
              >{{ $t('save') }}</ts-button
            >
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import StudentList from './component/student-list'
import ItemList from './component/item-list'
import Academic from './component/academic'
import PreviewPDF from './component/preview-pdf'
import moment from 'moment'
import { Errors } from 'form-backend-validation'

export default {
  name: 'preInvoiceCreate',
  components: {
    StudentList,
    ItemList,
    Academic
  },
  data() {
    return {
      model: {
        pre_inv_date: moment().format('DD-MM-YYYY'),
        student_id: '',
        ac_year_id: '',
        acp_id: '',
        ac_status_id: '',
        term_stop: '',
        acps_id: '',
        ac_term_id: null,
        grade_id: null,
        study_time: '',
        total_amount: '',
        remark: '',
        vehicle_id: '',
        preview: true,
        inv_detail_list: []
      },
      errors: new Errors(),
      save_waiting: false,
      save_add_new_waiting: false,
      studentInfo: null
    }
  },
  created() {},
  methods: {
    save() {
      this.errors = new Errors()
      this.save_waiting = true
      this.$store
        .dispatch('preInvoice/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          if (this.model.preview) {
            this.$modal.show(
              PreviewPDF,
              {
                url: response.url
              },
              {
                height: 'auto',
                width: '50%',
                scrollable: true,
                draggable: '.form-header',
                clickToClose: false
              },
              {
                'before-close': this.pushBack
              }
            )
          } else {
            this.pushBack()
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.save_waiting = false
        })
    },
    saveAddNew() {
      this.errors = new Errors()
      this.save_add_new_waiting = true
      this.$store
        .dispatch('preInvoice/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          if (this.model.preview) {
            this.$modal.show(
              PreviewPDF,
              {
                url: response.url
              },
              {
                height: 'auto',
                width: '50%',
                scrollable: true,
                draggable: '.form-header',
                clickToClose: false
              },
              {
                'before-close': this.clearInput
              }
            )
          } else {
            this.clearInput()
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.save_add_new_waiting = false
        })
    },
    pushBack() {
      this.$router.push({ name: 'pre-invoice' })
    },
    clearInput() {
      this.model.pre_inv_date = moment().format('DD-MM-YYYY');
      this.model.student_id = '';
      this.model.ac_year_id = '';
      this.model.acp_id = '';
      this.model.acps_id = '';
      this.model.ac_term_id = null;
      this.model.grade_id = null;
      this.model.study_time = '';
      this.model.total_amount = '';
      this.model.remark = '';
      this.model.term_stop = '';
      this.model.vehicle_id = '';
      this.model.preview = false;
      this.model.inv_detail_list = []
      this.studentInfo = null
    }
  }
}
</script>
